/* tslint:disable */
var TBaseMultiOptions =
{
    isRenderedIcon: false,
    buildCombo () { },

    buildUKMultiplesOptions (mode, selections) { },

    // tsystem.js - buildComboVariants
    buildSystem () { },

    buildComboBonusIcon(betType, freeBet, mode)
    {
        var __html = "",
            isSelectedFreeBet = (freeBet && freeBet.SelectedID != 0);
        if (mode.SelectedEWVariants && !mode.SelectedEWVariants[betType] && !isSelectedFreeBet)
        {
            __html += TComboBonusPresenter.buildView.buildMultiOptions(betType);
            if (ComboBonusProvider.ComboBonuses && ComboBonusProvider.ComboBonuses[betType] && !Modes.isCombinatorMode(mode))
             {
                this.isRenderedIcon = true;
             }
        }
        return __html;
    },

    createComboVariantLine () { },

    createUKComboVariantLine () { },

    createSystemVariantLine () { },

    createUKSystemVariantLine () { },

    // tcombo.js - buildComboOptions ; TMultiOptions.js - buildUKMultiplesOptions
    buildComboInner (mode, selections)
    {
        var selectionsCount = Object.keys(mode.SelectionsInCombo).length;
        var linesCount = Array.getLength(BetSlip.Selections);
        var i, len, keys, options = <any> {};
        var __html = "";

        if (Modes.showComboNotAllowedMessage(mode))
        {
            __html += TSlipShared.createOptionsMessage($dict.bs("SameEvent"));
        }
        else if (typeof BetSlipRegulations !== "undefined" && BetSlipRegulations.IsItalian && linesCount <= 2 && mode instanceof ComboSPSlipMode)
        {
            __html += TSlipShared.createOptionsMessage($string("shoppingCart").ComboSystemOptionsEmpty);
            return __html;
        }
        else if (selectionsCount < mode.MinSelections && !Modes.isCombinatorMode(mode))
        {
            __html += TSlipShared.createOptionsMessage(Selections.getMinSelectionsMessage(mode));
            return __html;
        }
        else if (linesCount < mode.MinSelections)
        {
            __html += TSlipShared.createOptionsMessage($dict.bs("ComboOptionsEmpty"));
            return __html;
        }

        if (typeof mode.hasStraightCombo === "function" && !mode.hasStraightCombo())
        {
            mode.clearStraightComboDeposit();
            return __html;
        }

        var startIndex = mode.getStartIndex();
        var variantsLength = mode.Variants.length;
        for (var key = startIndex; key < variantsLength && key <= BetSlip.maxSelectionsNumber; key++)
        {
            if (mode.ComboNoCombinations && key < variantsLength - 1)
            {
                mode.setDeposit(key, 0);
                continue;
            }
        }

        options.hasEachway = mode.CheckForEachWayEnabled();
        options.ewIncluded = mode.CheckForEachWayIncluded();

        var isFirst = true;

        if (linesCount <= BetSlip.maxSelectionsNumber && Modes.showCombinations(mode))
        {
            keys = Object.keys(mode.Variants);

            var variantsStartIndex = Modes.getVariantsStartIndex(mode);
            variantsStartIndex = (variantsStartIndex !== -1) ? variantsStartIndex : 0;

            for (i = variantsStartIndex, len = keys.length; i < len; i += 1)
            {
                options.key = keys[i];
                options.deposit = Bets.formatStake(mode.VariationsDeposits[options.key]);
                options.betsCount = Modes.getVariationBetsCount(mode, options.key, options.ewIncluded);

                if (options.betsCount == 0 || options.betsCount >= mode.MaxPermutationsPerBet)
                {
                    continue;
                }
                options.betsCount == 1 ? (
                    options.odds = Modes.getMultiOdds(mode),
                    options.comboName = $dict.bs("ComboNamesOneBetOdds")
                ) : options.comboName = $dict.bs("ComboNamesBets");

                if (mode.IsUKBetSlip)
                {
                    options = this.getUKBetSlipOptions(mode, selections, options, { ukSubMode: UKSlipModeSubModes.Combo });
                    __html += this.createUKComboVariantLine(mode, options, selections, i);
                }
                else
                {
                    __html += this.createComboVariantLine(mode, options, selections, i, isFirst);
                }

                isFirst = false;
            }
        }

        return __html;
    },
    getUKBetSlipOptions(mode, selections, options, customOptions)
    {
        return $.extend({}, options, customOptions);
    },
    // TMultiOptions.js - buildUKMultiplesOptions
    buildUKSystemInner (mode, selections)
    {
        var __html = "";

        if (!mode.canActivateSystem())
        {
            return "";
        }

        var Lines = mode.getSelections();
        var ComboGroups = mode.getSelectionGroups();
        var cg = Array.getLength(ComboGroups);
        var tooManySystems = mode.getNumberOfParallelSystems() > mode.MaxParallelSystems;
        var linesCount = Array.getLength(BetSlip.Selections);
        var options = <any> {};
        options.hasEachway = mode.CheckForSystemEachWayEnabled();

        if (linesCount <= BetSlip.maxSelectionsNumber)
        {
            if (mode.SystemMinSelections <= cg && cg <= mode.NamedSystemLimit && !tooManySystems)
            {
                options.key = cg;
                __html += this.buildSystemVariantLineInner(options, Lines, mode, cg);
            }

            if (mode.SystemMinSelections <= cg && cg < (mode.NamedSystemLimit - 1) && !tooManySystems)
            {
                options.key = cg + 1;
                __html += this.buildSystemVariantLineInner(options, Lines, mode, cg);
            }
        }

        return __html;
    },

    buildSystemVariantLineInner (options, lines, mode, cg)
    {
        options = this.getUKBetSlipOptions(mode, lines, options, {
            deposit: Bets.formatStake(mode.SystemDeposits[options.key]),
            betsCount: mode.getSystemNumberOfBets(options.key),
            systemName: $dict.bs("SystemNames_{0}_{1}".format(cg, options.key)),
            betsString: $dict.bs("ComboNamesBets"),
            ewIncluded: mode.SelectedSystemEWVariants[options.key],
            ukSubMode: UKSlipModeSubModes.System
        });
        
        return this.createUKSystemVariantLine(mode, options, lines);
    },

    buildSystemInnerLayout () { },

    // tsystem.js - buildComboVariants
    buildSystemInner (mode, selections)
    {
        var __html = "";
        var lines = mode.getSelections();
        var comboGroups = mode.getSelectionGroups();

        var options = <any> {};
        options.hasEachway = mode.CheckForEachWayEnabled();
        options.ewIncluded = mode.CheckForEachWayIncluded();
        options.groupCount = Array.getLength(comboGroups);
        options.tooManySystems = mode.getNumberOfParallelSystems() > mode.MaxParallelSystems;
        options.deposit = mode.SystemDeposit ? mode.SystemDeposit.toStringEx("#.##") : "0";
        options.linesCount = Array.getLength(lines);

        if (Modes.showComboNotAllowedMessage(mode)) {
            __html += TSlipShared.createOptionsMessage($dict.bs("SameEvent"));
        } else if (options.groupCount < mode.MinSelections) {
            __html += TSlipShared.createOptionsMessage($dict.bs("SystemMinSelectionMessage"));
            return __html;
        } else if (options.groupCount > mode.MaxSelections) {
            __html += TSlipShared.createOptionsMessage($dict.bs("SystemMaxSelectionMessage"));
        } else if (options.linesCount <= 1) {
            __html += TSlipShared.createOptionsMessage($dict.bs("SystemOptionsEmpty"));
            return __html;
        } else if (options.tooManySystems && options.groupCount <= mode.NamedSystemLimit) {
            __html += TSlipShared.createOptionsMessage($dict.bs("SystemOptionsTooManyIncompatible"));
        }

        __html += this.buildSystemInnerLayout(mode, options);
        return __html;
    },

    buildSystemOptionGroups() { },

    buildSystemIndividualVariants(mode, options)
    {
        var key, __html = "";

        // If this option is not visible - we choose next biggest option
        if (mode.SystemKey > options.groupCount)
        {
            if (mode.MinSelections <= options.groupCount && options.groupCount < (mode.MaxSelections - 1))
            {   //Special case for Super Heinz (7 lines)
                mode.SystemKey = options.groupCount + (options.groupCount == mode.NamedSystemLimit - 1 ? 0 : 1);
            }
            else
            {
                mode.SystemKey = options.groupCount;
            }
        }

        for (key = 2; key < options.groupCount; key += 1)
        {
            options.key = key;
            options.betsCount = mode.getNumberOfBets(options.key);
            if (options.betsCount == 0 || options.betsCount >= mode.MaxPermutationsPerBet)
            {
                continue;
            }

            if (mode.SystemKey == 0)
            {
                mode.SystemKey = 2;
            }

            options.systemName = "{0} {1}/{2}".format($dict.bs("SystemName"), options.key, options.groupCount);

            __html += this.createSystemVariantLine(mode, options);
        }

        return __html;
    },

    buildSystemNamedVariants(mode, options)
    {
        var __html = "";
        //All combo variants, no singles
        if (mode.MinSelections <= options.groupCount && options.groupCount <= mode.NamedSystemLimit && !options.tooManySystems)
        {
            options.key = options.groupCount;
            __html += this.buildSystemNamedVariantsLine(mode, options);
        }

        //All combo variants with singles
        if (mode.MinSelections <= options.groupCount && options.groupCount < (mode.NamedSystemLimit - 1) && !options.tooManySystems)
        {
            options.key = options.groupCount + 1;
            __html += this.buildSystemNamedVariantsLine(mode, options);
        }
        return __html;
    },

    buildSystemNamedVariantsLine(mode, options)
    {
        options.betsCount = mode.getNumberOfBets(options.key);
        options.systemName = $dict.bs("SystemNames_{0}_{1}".format(options.groupCount , options.key));
        return this.createSystemVariantLine(mode, options);
    },

    // tteaser.js - buildTeaserOptions
    buildTeaserInner (mode, selections)
    {
        var selectionsCount = Object.keys(mode.SelectionsInTeaser).length;
        if (selectionsCount < mode.MinSelections) {
            return TSlipShared.createOptionsMessage($dict.bs("TeaserOptionsEmpty"));
        } else {
            return TTeaserOptions.buildOptions(mode, selections);
        }
    },

    createMultiFreeBetSelect (mode, selections, variantKey)
    {
        var freeBetsData = Modes.getAvailableMultiFreeBets(mode, selections, variantKey);
        if (!freeBetsData) { return ""; }
        return TSlipShared.createFreeBetDropDown(freeBetsData, UKSlipModeSubModes.Combo);
    },

    createUKMultiFreeBetSelect (mode, selections, variantKey)
    {
        var freeBetsData = Modes.getAvailableFreeBetsForUKSlip(mode, UKSlipModeSubModes.Combo, null, selections, variantKey);
        if (!freeBetsData) { return ""; }
        return TSlipShared.createFreeBetDropDown(freeBetsData, UKSlipModeSubModes.Combo);
    },

    buildQuickStakeButtons (mode)
    {
        if (!BetSlipUtil.shouldBuildQuickStake(mode)) { return ""; }
        var keys = Object.keys(mode.Variants);
        var index = Modes.getVariantsStartIndex(mode);
        var comboNumber = keys[index];

        return QuickStake.buildView(comboNumber, QuickStake.getQuickStakeSeries());
    },

    getComboVariantStakeBoxInner (options)
    {
        return function (__html)
        {
            var attributes = TSlipShared.createStakeInputAttributes("UniSlipBlock.setComboStake(" + options.key + ", this)");

            options.deposit = BetSlip.CurrentMode.setDefaultStake(options);
            BetSlip.CurrentMode.setDeposit(options.key, options.deposit);

            var formattedDeposit = BetSlip.getStakeBoxValue(options.deposit);

            __html.push(`<input class="stakebox" data-uat="stakebox" rel="combobetInputFields" id="${BetSlipUtil.getComboStakeBoxID(options)}" value="${formattedDeposit}" ${attributes} />`);
        };
    },

    getSystemVariantStakeBoxInner (options)
    {
        return function (__html)
        {
            options.deposit = BetSlip.CurrentMode.setDefaultSystemStake(options);
            var formattedDeposit = BetSlip.getStakeBoxValue(options.deposit);

            __html.push(`<input class="stakebox" data-uat="stakebox" id="${BetSlipUtil.getSystemStakeBoxID(options)}" value="${formattedDeposit}" ${TSlipShared.createStakeInputAttributes(`UniSlipBlock.setSystemStake(${options.key}, this)`)} />`);
        };
     },

    getAllStakeBoxInner (deposit)
    {
        return function (__html)
        {
            __html.push(`<input class="stakebox" data-uat="stakebox" id="setStakeForAll" value="${deposit}" ${TSlipShared.createStakeInputAttributes("UniSlipBlock.setStakeToAll(this)")} />`);
        }
    },

    buildComboBonusMessageInSystem (mode)
    {
        var sysKey = mode.SystemKey;
        if (!mode.NamedSystemOdds[sysKey] && !mode.EachWayIncluded)
        {
            return TComboBonusPresenter.buildComboBonusMessage(sysKey);
        }
        return "";
    },

    buildComboBonusIconInSystem(mode, options)
    {
        var key = options.key;
        if (!mode.NamedSystemOdds[key] && !mode.EachWayIncluded)
        {
            return TComboBonusPresenter.buildView.buildMultiOptions(key);
        }
        return "";
    },

   buildComboBonusMessage (isRenderedIcon)
   {
       var extraWinningRow = document.getElementById("extraWinningsRow");
       if (!extraWinningRow) {
           return "";
       }
       if (isRenderedIcon)
       {
           extraWinningRow.classList.remove("isHidden");
           return TComboBonusPresenter.buildComboBonusMessageHTML();
       }
       else
       {
           extraWinningRow.classList.add("isHidden");
       }
       return "";
   },

    buildSystemStakeAndEWBoxes (mode, options)
    {
        var __html = "";
        if (options.hasEachway) {
            __html += this.createEachwayBox.defaultBox(mode, options);
        }
        __html += TSlipShared.createStakeBox(this.getSystemVariantStakeBoxInner(options), options.deposit);
        __html += TSlipShared.createSystemMaxBet(mode);
        return __html;
    },

    buildComboOptionsTitle (mode)
    {
        if (Modes.isComboNoCombinationSingleMode(mode)) {
            return "";
        }

        return `
            <div class="heading">
                <label for="comboOptions">
                    ${$dict.bs("ComboOptionsTitle")}
                </label>
            </div>
        `;
    },

    createEachwayBox:
    {
        defaultBox (mode, options)
        {
            return `
                <div class="betSlipEachWay type_default" data-uat="bet-slip-each-way">
                    <label for="${BetSlipUtil.getDefaultEachWayBoxID(options)}">
                        <strong class="betSlipEachWay__title" data-uat="bet-slip-each-way-label">
                            ${$string("General").EachWayTag}
                        </strong>
                        ${this.buildCheckBoxInput(mode, options, "default")}
                        <span class="icon i-24 i-o-controls-checkmark"></span>
                    </label>
                </div>
            `;
        },

        UKBox (mode, options)
        {
            return `
                <div class="betSlipEachWay type_uk" data-uat="bet-slip-each-way">
                    <label for="${BetSlipUtil.getUKEachWayBoxID(options)}">
                        ${this.buildCheckBoxInput(mode, options, "uk")}
                        <span class="icon i-24 i-o-controls-checkmark"></span>
                        <strong class="betSlipEachWay__title" data-uat="bet-slip-each-way-label">
                            ${$string("General").EachWayTag}
                        </strong>
                    </label>
                </div>
            `;
        },

        buildCheckBoxInput(mode, options, type)
        {
            var context = BetSlipUtil.buildCheckBoxContextForMultiOptions(mode, options, type);
            return `<input class="chck" type="checkbox" id="${context.id}" onclick=${context.onClick} ${context.checked} data-uat="bet-slip-each-way-checkbox" />`;
        }
    }
}

window.TBaseMultiOptions = TBaseMultiOptions;